import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { distinctUntilChanged, map, Observable } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { PropertySetsStateProviderService } from '../property-set-list/property-set-list-state.service';
import { STATE_PROVIDER, StateProvider } from '../services/state-provider/state-provider';
import { PropertySetListModule } from '../property-set-list/property-set-list.module';
import { PropertySetsHttpService } from '../services/http/property-sets-http.service';
import { PropertySetModule } from '../property-set-details/property-set.module';
import { PropertySetDialogData, PropertySetsState, PropertySetView } from './property-sets-dialog';
import { PropertySetOperationsTrackerService } from '../services/property-set-operations-tracker.service';

@UntilDestroy()
@Component({
  selector: 'miq-property-sets-dialog',
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, PropertySetListModule, PropertySetModule],
  template: `
    <ng-container *ngIf="view$ | async as view">
      <div *ngIf="view === 'list'" class="ps-property-set-list-wrapper">
        <miq-property-set-list></miq-property-set-list>
      </div>
      <div *ngIf="view === 'details'" class="ps-property-set-wrapper">
        <miq-property-set></miq-property-set>
      </div>
    </ng-container>
  `,
  styleUrls: ['./property-sets-dialog.component.scss'],
  providers: [PropertySetsHttpService, { provide: STATE_PROVIDER, useExisting: PropertySetsStateProviderService }],
})
export class PropertySetsDialogComponent implements OnInit {
  public view$: Observable<PropertySetView> = null;

  constructor(
    public dialogRef: MatDialogRef<PropertySetsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PropertySetDialogData,
    @Inject(STATE_PROVIDER) private stateProvider: StateProvider<PropertySetsState>,
    private operationsTracker: PropertySetOperationsTrackerService
  ) {}

  ngOnInit(): void {
    this.operationsTracker.clearOperations();
    this.stateProvider.patchState({ ...this.data });

    this.view$ = this.stateProvider.stateChanges$.pipe(
      untilDestroyed(this),
      map(state => state.view),
      distinctUntilChanged()
    );
  }
}
